// user profile
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const USER_PROFILE_ERROR = 'USER_PROFILE_ERROR';

// Dashboard
export const FETCH_DASHBOARD_REQUEST = 'FETCH_DASHBOARD_REQUEST';
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS';
export const FETCH_DASHBOARD_FAILURE = 'FETCH_DASHBOARD_FAILURE';

// Groups
export const GET_GROUPS = 'GET_GROUPS';
export const GETTING_GROUPS = 'GETTING_GROUPS';
export const CREATE_GROUP = 'CREATE_GROUP';
export const CREATING_GROUP = 'CREATING_GROUP';
export const GROUPS_ERROR = 'GROUPS_ERROR';

// Downloadables
export const GET_DOWNLOADABLES = 'GET_DOWNLOADABLES';
export const GETTING_DOWNLOADABLES = 'GETTING_DOWNLOADABLES';
export const CREATE_DOWNLOADABLE = 'CREATE_DOWNLOADABLE';
export const CREATING_DOWNLOADABLE = 'CREATING_DOWNLOADABLE';
export const UPDATE_DOWNLOADABLE = 'UPDATE_DOWNLOADABLE';
export const UPDATING_DOWNLOADABLE = 'UPDATING_DOWNLOADABLE';
export const DELETE_DOWNLOADABLE = 'DELETE_DOWNLOADABLE';
export const DELETING_DOWNLOADABLE = 'DELETING_DOWNLOADABLE';
export const DOWNLOADABLES_ERROR = 'DOWNLOADABLES_ERROR';

// traits
export const GET_TRAITS = 'GET_TRAITS';
export const GETTING_TRAITS = 'GETTING_TRAITS';
export const CREATE_TRAIT = 'CREATE_TRAIT';
export const CREATING_TRAIT = 'CREATING_TRAIT';
export const UPDATE_TRAIT = 'UPDATE_TRAIT';
export const UPDATING_TRAIT = 'UPDATING_TRAIT';
export const DELETE_TRAIT = 'DELETE_TRAIT';
export const DELETING_TRAIT = 'DELETING_TRAIT';
export const TRAITS_ERROR = 'TRAITS_ERROR';

// Results
export const GET_RESULTS = 'GET_RESULTS';
export const GETTING_RESULTS = 'GETTING_RESULTS';
export const RESULTS_ERROR = 'RESULTS_ERROR';

// Student traits
export const GET_STUDENT_TRAITS = 'GET_STUDENT_TRAITS';
export const GETTING_STUDENT_TRAITS = 'GETTING_STUDENT_TRAITS';
export const UPDATING_STUDENT_TRAITS = 'UPDATING_STUDENT_TRAITS';
export const UPDATE_STUDENT_TRAITS = 'UPDATE_STUDENT_TRAITS';

// Admissions
export const GET_ADMISSION_OFFERS = 'GET_ADMISSION_OFFERS';
export const GETTING_ADMISSION_OFFERS = 'GETTING_ADMISSION_OFFERS';
export const ADMISSION_OFFERS_ERROR = 'ADMISSION_OFFERS_ERROR';

// Admissions
export const GET_ADMISSIONS = 'GET_ADMISSIONS';
export const GETTING_ADMISSIONS = 'GETTING_ADMISSIONS';
export const ADMISSIONS_ERROR = 'ADMISSIONS_ERROR';

// Payments
export const GET_PAYMENTS = 'GET_PAYMENTS';
export const GETTING_PAYMENTS = 'GETTING_PAYMENTS';
export const PAYMENTS_ERROR = 'PAYMENTS_ERROR';

// Applications
export const GET_APPLICATIONS = 'GET_APPLICATIONS';
export const GETTING_APPLICATIONS = 'GETTING_APPLICATIONS';
export const CREATE_APPLICATION = 'CREATE_APPLICATION';
export const CREATING_APPLICATION = 'CREATING_APPLICATION';
export const UPDATING_APPLICATION = 'UPDATING_APPLICATION';
export const UPDATED_APPLICATION = 'UPDATED_APPLICATION';
export const APPLICATIONS_ERROR = 'APPLICATIONS_ERROR';

// Application responses
export const GET_APPLICATION_RESPONSES = 'GET_APPLICATION_RESPONSES';
export const GETTING_APPLICATION_RESPONSES = 'GETTING_APPLICATION_RESPONSES';
export const CREATE_APPLICATION_RESPONSE = 'CREATE_APPLICATION_RESPONSE';
export const CREATING_APPLICATION_RESPONSE = 'CREATING_APPLICATION_RESPONSE';
export const APPLICATION_RESPONSES_ERROR = 'APPLICATION_RESPONSES_ERROR';

// Students
export const GET_STUDENTS = 'GET_STUDENTS';
export const GETTING_STUDENTS = 'GETTING_STUDENTS';
// export const CREATE_APPLICATION = 'CREATE_APPLICATION';
// export const CREATING_APPLICATION = 'CREATING_APPLICATION';
export const UPDATING_STUDENT = 'UPDATING_STUDENT';
export const UPDATED_STUDENT = 'UPDATED_STUDENT';
export const STUDENTS_ERROR = 'STUDENTS_ERROR';

// Examination centers
export const GETTING_EXAMINATION_CENTERS = 'GETTING_EXAMINATION_CENTERS';
export const GET_EXAMINATION_CENTERS = 'GET_EXAMINATION_CENTERS';
export const EXAMINATION_CENTERS_ERROR = 'EXAMINATION_CENTERS_ERROR';

// document requests
export const GET_DOCUMENT_REQUESTS = 'GET_DOCUMENT_REQUESTS';
export const GETTING_DOCUMENT_REQUESTS = 'GETTING_DOCUMENT_REQUESTS';
export const CREATE_DOCUMENT_REQUEST = 'CREATE_DOCUMENT_REQUEST';
export const CREATING_DOCUMENT_REQUEST = 'CREATING_DOCUMENT_REQUEST';
export const UPDATE_DOCUMENT_REQUEST = 'UPDATE_DOCUMENT_REQUEST';
export const UPDATING_DOCUMENT_REQUEST = 'UPDATING_DOCUMENT_REQUEST';
export const DOCUMENT_REQUESTS_ERROR = 'DOCUMENT_REQUESTS_ERROR';

// Invoices
export const GET_INVOICES = 'GET_INVOICES';
export const GETTING_INVOICES = 'GETTING_INVOICES';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const CREATING_INVOICE = 'CREATING_INVOICE';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const UPDATING_INVOICE = 'UPDATING_INVOICE';
export const INVOICES_ERROR = 'INVOICES_ERROR';

// Invoice assignments
export const GET_INVOICE_ASSIGNMENTS = 'GET_INVOICE_ASSIGNMENTS';
export const GETTING_INVOICE_ASSIGNMENTS = 'GETTING_INVOICE_ASSIGNMENTS';
export const CREATING_INVOICE_ASSIGNMENT = 'CREATING_INVOICE_ASSIGNMENT';
export const CREATE_INVOICE_ASSIGNMENT = 'CREATE_INVOICE_ASSIGNMENT';

// sundry accounts
export const GET_SUNDRY_ACCOUNTS = 'GET_SUNDRY_ACCOUNTS';
export const GETTING_SUNDRY_ACCOUNTS = 'GETTING_SUNDRY_ACCOUNTS';
export const GETTING_SUNDRY_TRANSACTIONS = 'GETTING_SUNDRY_TRANSACTIONS'
export const GET_SUNDRY_TRANSACTIONS = 'GET_SUNDRY_TRANSACTIONS'
export const CREATING_SUNDRY_TRANSACTION = 'CREATING_SUNDRY_TRANSACTION'
export const CREATE_SUNDRY_TRANSACTION = 'CREATE_SUNDRY_TRANSACTION'
export const SUNDRIES_ERROR = 'SUNDRIES_ERROR';

// Sundry items
export const GET_SUNDRY_ITEMS = 'GET_SUNDRY_ITEMS';
export const GETTING_SUNDRY_ITEMS = 'GETTING_SUNDRY_ITEMS';
export const CREATE_SUNDRY_ITEM = 'CREATE_SUNDRY_ITEM';
export const CREATING_SUNDRY_ITEM = 'CREATING_SUNDRY_ITEMS';
export const DELETE_SUNDRY_ITEM = 'DELETE_SUNDRY_ITEM';
export const DELETING_SUNDRY_ITEM = 'DELETING_SUNDRY_ITEM';
export const UPDATING_SUNDRY_ITEM = 'UPDATING_SUNDRY_ITEM';
export const UPDATE_SUNDRY_ITEM = 'UPDATE_SUNDRY_ITEM';

// Classes
export const GET_CLASSES = 'GET_CLASSES';
export const GETTING_CLASSES = 'GETTING_CLASSES';
export const UPDATE_CLASS = 'UPDATE_CLASS';
export const UPDATING_CLASS = 'UPDATING_CLASS';
export const CLASSES_ERROR = 'CLASSES_ERROR';

// class divisions
export const GET_CLASS_DIVISIONS = 'GET_CLASS_DIVISIONS';
export const GETTING_CLASS_DIVISIONS = 'GETTING_CLASS_DIVISIONS';
export const UPDATE_CLASS_DIVISION = 'UPDATE_CLASS_DIVISION';
export const UPDATING_CLASS_DIVISION = 'UPDATING_CLASS_DIVISION';
export const CREATE_CLASS_DIVISION = 'CREATE_CLASS_DIVISION';
export const CREATING_CLASS_DIVISION = 'CREATING_CLASS_DIVISION';

// Academic sessions
export const GET_ACADEMIC_SESSIONS = 'GET_ACADEMIC_SESSIONS';
export const GETTING_ACADEMIC_SESSIONS= 'GETTING_ACADEMIC_SESSIONS';
export const CREATE_ACADEMIC_SESSION = 'CREATE_ACADEMIC_SESSION';
export const CREATING_ACADEMIC_SESSION = 'CREATING_ACADEMIC_SESSION';
export const UPDATE_ACADEMIC_SESSION= 'UPDATE_ACADEMIC_SESSION';
export const UPDATING_ACADEMIC_SESSION= 'UPDATING_ACADEMIC_SESSION';
export const ACADEMIC_SESSIONS_ERROR = 'ACADEMIC_SESSIONS_ERROR';

// Subjects
export const GET_SUBJECTS = 'GET_SUBJECTS';
export const GETTING_SUBJECTS = 'GETTING_SUBJECTS';
export const CREATE_SUBJECT = 'CREATE_SUBJECT';
export const CREATING_SUBJECT = 'CREATING_SUBJECT';
export const UPDATE_SUBJECT = 'UPDATE_SUBJECT';
export const UPDATING_SUBJECT = 'UPDATING_SUBJECT';
export const DELETING_SUBJECT = 'DELETING_SUBJECT';
export const DELETE_SUBJECT = 'DELETE_SUBJECT';
export const SUBJECTS_ERROR = 'SUBJECTS_ERROR';

// Exeats
export const GET_EXEATS = 'GET_EXEATS';
export const GETTING_EXEATS = 'GETTING_EXEATS';
export const CREATE_EXEAT = 'CREATE_EXEAT';
export const CREATING_EXEAT = 'CREATING_EXEAT';
export const UPDATE_EXEAT = 'UPDATE_EXEAT';
export const UPDATING_EXEAT = 'UPDATING_EXEAT';
export const DELETE_EXEAT = 'DELETE_EXEAT';
export const DELETING_EXEAT = 'DELETING_EXEAT';
export const EXEATS_ERROR = 'EXEATS_ERROR';

// Assessments
export const GET_ASSESSMENTS = 'GET_ASSESSMENTS';
export const GETTING_ASSESSMENTS = 'GETTING_ASSESSMENT';
export const GET_ASSESSMENT_RECORDS = 'GET_ASSESSMENT_RECORDS';
export const GETTING_ASSESSMENT_RECORDS = 'GETTING_ASSESSMENT_RECORDS';
export const CREATE_ASSESSMENT_RECORD = 'CREATE_ASSESSMENT_RECORD';
export const CREATING_ASSESSMENT_RECORD = 'CREATING_ASSESSMENT_RECORD';
export const UPDATE_ASSESSMENT_RECORD = 'UPDATE_ASSESSMENT_RECORD';
export const UPDATING_ASSESSMENT_RECORD = 'UPDATING_ASSESSMENT_RECORD';
export const DELETE_ASSESSMENT_RECORD = 'DELETE_ASSESSMENT_RECORD';
export const DELETING_ASSESSMENT_RECORD = 'DELETING_ASSESSMENT_RECORD';
export const ASSESSMENTS_ERROR = 'ASSESSMENTS_ERROR';

// Disciplinary records
export const GET_DISCIPLINARY_RECORDS = 'GET_DISCIPLINARY_RECORDS';
export const GETTING_DISCIPLINARY_RECORDS = 'GETTING_DISCIPLINARY_RECORDS';
export const CREATE_DISCIPLINARY_RECORD = 'CREATE_DISCIPLINARY_RECORD';
export const CREATING_DISCIPLINARY_RECORD = 'CREATING_DISCIPLINARY_RECORD';
export const UPDATE_DISCIPLINARY_RECORD = 'UPDATE_DISCIPLINARY_RECORD';
export const UPDATING_DISCIPLINARY_RECORD = 'UPDATING_DISCIPLINARY_RECORD';
export const DELETE_DISCIPLINARY_RECORD = 'DELETE_DISCIPLINARY_RECORD';
export const DELETING_DISCIPLINARY_RECORD = 'DELETING_DISCIPLINARY_RECORD';
export const DISCIPLINARY_RECORDS_ERROR = 'DISCIPLINARY_RECORDS_ERROR';


// Student feedback
export const GET_STUDENT_FEEDBACK = 'GET_STUDENT_FEEDBACK';
export const GETTING_STUDENT_FEEDBACK = 'GETTING_STUDENT_FEEDBACK';
export const CREATE_STUDENT_FEEDBACK = 'CREATE_STUDENT_FEEDBACK';
export const CREATING_STUDENT_FEEDBACK = 'CREATING_STUDENT_FEEDBACK';
export const UPDATE_STUDENT_FEEDBACK = 'UPDATE_STUDENT_FEEDBACK';
export const UPDATING_STUDENT_FEEDBACK = 'UPDATING_STUDENT_FEEDBACK';
export const DELETE_STUDENT_FEEDBACK = 'DELETE_STUDENT_FEEDBACK';
export const DELETING_STUDENT_FEEDBACK = 'DELETING_STUDENT_FEEDBACK';
export const STUDENT_FEEDBACK_ERROR = 'STUDENT_FEEDBACK_ERROR';

// Errors
export const ERROR = 'ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'

// Success
export const SET_SUCCESS = 'SET_SUCCESS'
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS'